export default __webpack_public_path__ + "static/media/110-focus-hopeful.c7c7e463.jpeg";